<template>
    <div>
        <ts-page-title :title="$t('productCategory.pageTitle')" />
        <ts-panel>
            <ts-panel-wrapper>
                <div class="d-flex justify-content-between">
                    <Button type="info" ghost @click="addNew">
                        {{ $t('addNew') }}
                    </Button>
                    <div class="tw-justify-end tw-space-x-2">
                        <Input
                            search
                            v-model="search"
                            :placeholder="$t('productCategory.search')"
                            :style="width"
                            @on-focus="() => (width = 'width: 500px')"
                            @on-blur="() => (width = 'width: 300px')"
                        />
                    </div>
                </div>
            </ts-panel-wrapper>
            <Table
                :columns="columns"
                :data="resources"
                size="small"
                :loading="loading"
                max-height="700"
                stripe
            >
                <template slot-scope="{ row }" slot="icon">
                    <div v-html="row.icon"></div>
                </template>
                <template slot-scope="{ row }" slot="action">
                    <a
                        href="#"
                        class="text-primary ml-2"
                        @click.prevent="edit(row)"
                        v-tooltip="$t('edit')"
                    >
                        <Icon type="ios-create" size="20" />
                    </a>
                    <Poptip
                        confirm
                        :title="$t('areYouSure')"
                        @on-ok="deleteRecord(row)"
                        :transfer="true"
                        :ok-text="$t('yes')"
                        :cancel-text="$t('no')"
                    >
                        <a
                            class="ml-2 text-danger"
                            v-tooltip="$t('delete')"
                            :disabled="row._deleting"
                        >
                            <i
                                class="fas fa-circle-notch fa-spin"
                                v-if="row._deleting"
                            ></i>
                            <Icon type="ios-trash" size="20" v-else />
                        </a>
                    </Poptip>
                </template>
            </Table>
            <div class="tw-flex tw-items-center tw-justify-end tw-p-4">
                <ts-i-pagination
                    v-model="pagination"
                    @navigate="fetchData"
                ></ts-i-pagination>
            </div>
            <!-- form-action -->
            <Modal
                v-model="showForm"
                draggable
                scrollable
                :mask="false"
                footer-hide
                width="500px"
                :title="$t('productCategory.pageTitle')"
                centered
                :zIndex="1020"
                :closable="false"
            >
                <from-action
                    ref="form_action"
                    @cancel="clearEdit"
                    @fetchData="fetchData"
                />
            </Modal>
        </ts-panel>
    </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
    name: 'warehouseIndex',
    components: {
        FromAction
    },
    data () {
        return {
            loading: false,
            showForm: false,
            errors: new Errors(),
            width: 'width: 300px',
            visible: false
        }
    },
    computed: {
        ...mapState('product/productCategory', ['resources', 'pagination']),
        search: {
            get () {
                return this.$store.state.product.productCategory.search
            },
            set (newValue) {
                this.$store.commit(
                    'product/productCategory/SET_SEARCH',
                    newValue
                )
                this.$store.commit('product/productCategory/RESET_CURRENT_PAGE')
            }
        },
        columns () {
            return [
                {
                    title: this.$t('productCategory.code'),
                    key: 'category_code',
                    minWidth: 300,
                    sortable: true
                },
                {
                    title: this.$t('productCategory.nameKh'),
                    key: 'category_name_kh',
                    minWidth: 300,
                    sortable: true
                },
                {
                    title: this.$t('productCategory.nameEn'),
                    key: 'category_name_en',
                    minWidth: 250,
                    align: 'center',
                    sortable: true
                },
                {
                    title: this.$t('productCategory.icon'),
                    slot: 'icon',
                    align: 'center',
                    minWidth: 250
                },
                {
                    title: this.$t('actions'),
                    key: 'action',
                    slot: 'action',
                    fixed: 'right',
                    align: 'center',
                    width: 90
                }
            ]
        }
    },
    methods: {
        fetchData (attributes) {
            this.loading = true
            this.$store
                .dispatch('product/productCategory/fetch', { ...attributes })
                .then(() => {
                    this.loading = false
                })
                .catch(error => {
                    this.errors = new Errors(error.errors)
                    this.notice({ type: 'error', text: error.message })
                })
        },
        addNew () {
            this.$store.commit('product/productCategory/SET_EDIT_DATA', {})
            this.showForm = true
        },
        edit (record) {
            this.showForm = true
            this.$store.commit('product/productCategory/SET_EDIT_DATA', record)
            this.$refs.form_action.setEditData()
        },
        clearEdit () {
            this.$refs.form_action.clearInput()
            this.$store.commit('product/productCategory/SET_EDIT_DATA', {})
            this.showForm = false
        },
        deleteRecord (record) {
            record._deleting = true
            this.$store
                .dispatch('product/productCategory/destroy', record.category_id)
                .then(response => {
                    this.notice({
                        type: 'success',
                        text: response.message
                    })
                    this.fetchData()
                })
                .catch(error => {
                    this.errors = new Errors(error.errors)
                    this.notice({ type: 'error', text: error.message })
                })
                .finally(() => {
                    record._deleting = false
                })
        },
        notice (not) {
            this.$Notice[not.type]({
                title: 'PRODUCT CATEGORY',
                desc: not.text
            })
        }
    },
    watch: {
        search: debounce(function () {
            this.fetchData()
        }, 500)
    },
    beforeRouteLeave (to, from, next) {
        this.$store.commit('product/productCategory/RESET_STATE')
        next()
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.fetchData()
        })
    }
}
</script>
